<template>
    <vx-expandable-card>
        <template v-slot:header> Cloning Targets </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.cloning_targets"
                :options="cloningTargets"
                @search="searchCloningTargets"
                @option:selected="selectTeams"
                @option:deselected="deselectTeams"
                label="name"
                size="lg"
                multiple
                :closeOnSelect="false"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import { computed, onUnmounted } from 'vue';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { adminCloningTargetsClient } from '~/services';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const { response, createSearch, cancelSearch, cancelKey } = useSearchRequest(
    adminCloningTargetsClient,
    'clone-cloning-targets',
    350
);
const cloningTargets = computed(() => response.value ?? []);
const searchCloningTargets = createSearch(async (search) => {
    const { data } = await adminCloningTargetsClient.getCloningTargets(
        {
            query: search,
            sort_dir: 'desc',
        },
        { cancelKey }
    );

    return data.data;
});

searchCloningTargets('');

onUnmounted(() => cancelSearch());

const selectTeams = (cloningTargetsCollection) => {
    cloningTargetsCollection.forEach((cloningTarget) => {
        if (cloningTarget?.teams?.length) {
            // Filter teams which already exists.
            const filteredTeams = cloningTarget.teams.filter(
                (team) => !model.value.target_teams.some((targetTeam) => targetTeam.id === team.id)
            );
            model.value.target_teams = [...model.value.target_teams, ...filteredTeams];
        }
    });
};

const deselectTeams = (cloningTarget) => {
    // Filter curruent target teams.
    model.value.target_teams = model.value.target_teams.filter(
        (targetTeam) => !cloningTarget.teams.some((team) => team.id === targetTeam.id)
    );

    // Reselect teams from rest of targets.
    selectTeams(model.value.cloning_targets);
};
</script>
